module.exports = __webpack_public_path__ + "static/media/logo-d4sign.4ce6318f.png";